import { getBaseApiUrl, promiseRequest } from './ServiceApi';

export interface SurveyAttachment {
    id: number;
    name: string;
    dir: string;
}

export interface SurveyContact {
    id: number;
    name: string;
    email: string;
}

export interface SurveyTaskInfo {
    ticket_code: string;
    name: string;
    solution: string | null;
    attachments_solution: SurveyAttachment[];
    customer_contacts: SurveyContact[];
    already_responded: boolean;
}

export interface SurveySubmitPayload {
    solution_rating: number;
    solution_reason?: string | null;
    service_rating: number;
    service_reason?: string | null;
    email: string;
}

export default class SurveyApi {

    private getUrl(token: string): string {
        return getBaseApiUrl() + `task/survey/${encodeURIComponent(token)}/`;
    }

    async getByToken(token: string): Promise<SurveyTaskInfo> {
        return await promiseRequest(this.getUrl(token), 'GET', undefined, true, false);
    }

    async submit(token: string, payload: SurveySubmitPayload): Promise<void> {
        await promiseRequest(this.getUrl(token), 'POST', payload, true, false);
    }
}
